module.exports = "<p>\n  <button mat-raised-button (click)=\"createProposal()\">Create Proposal</button>\n</p>\n"